import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ProjectCommentCreate" }

import { ref, PropType } from "vue";
import { Project } from "@/types";
import api from "@/api";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import InnInput from "@/components/ds/input/Input.vue";
import { useUiStore } from "@/stores/ui";
import { dateToTimestamp } from "@/tools/date";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCommentCreate',
  props: {
    project: {
        type: Object as PropType<Project>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const uiStore = useUiStore();

const input = ref("");

const createComment = () => {
    if (input.value.length > 0) {
        const comment = {
            projectId: props.project.id,
            comment: input.value,
        };
        api.create(comment, "comments").then((response) => {
            comment.id = response.id;
            props.project.comments.push(comment);
            uiStore.message("Notitie aangemaakt..");
            input.value = "";
        });
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InnInput, {
      modelValue: input.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((input).value = $event)),
      placeholder: "Notitie"
    }, null, 8, ["modelValue"]),
    _createVNode(IconButton, {
      "icon-id": "plus",
      onClick: createComment,
      disabled: input.value.length === 0
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode(" Notitie toevoegen ")
      ])),
      _: 1
    }, 8, ["disabled"])
  ]))
}
}

})